import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { SiteFormStyle } from '../site/components/site-form-style'

export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings/apply-form')({
    component: ApplyForm,
})

function ApplyForm() {
    const { siteId } = Route.useParams()

    return <SiteFormStyle siteId={siteId} />
}
